import React, { useEffect, useState } from "react";
import MediaCardTemplate from "pages/gant/components/factories/MediaCardTemplate";
import { enCours } from "constants/taskStatus";
import { Card, CardActions } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import Notification from "commons/notifications/Notification";
import { getKeys } from "commons/helpers/NotificationHelper";
import { useNavigate } from "react-router-dom";
import { useGetTachesQuery, useLazyGetTachesUsagerQuery } from "../../redux/api/cache";
import { useAppSelector } from "../../redux/store";

export default function Notifications() {
    const user = useAppSelector(state => state.appState.user);
    const [sortedTasks, setSortedTasks] = useState([]);
    const { data: task, isLoading, isFetching } = useGetTachesQuery({ usr_cd: user, filtre: 'usager' }, { skip: !user });
    const [getTaskUsager] = useLazyGetTachesUsagerQuery();
    const navigate = useNavigate();

    useEffect(() => {
        const initializeTasks = async () => {
            const userTasks = [];
            if (!isFetching && !isLoading) {
                if (task?.data && task.data.length > 0) {
                    var promise = task.data.map(async d => {
                        return getTaskUsager({ tac_id: d.tac_id, usr_cd: user }, true);
                    });
                    var result = await Promise.all(promise);
                    result.forEach(r => {
                        if (r.data.success && r.data.data[0].tacusr_statut === enCours) {
                            userTasks.push(r.data.data[0].tac_id);
                        }
                    });
                    setSortedTasks(task?.data && task.data.length > 0 ? [...task.data].filter(d => userTasks.includes(d.tac_id)).sort((a, b) => a.tac_date.localeCompare(b.tac_date)) : []);
                }
                else
                    setSortedTasks([]);
            }
        };
        initializeTasks();
    }, [getTaskUsager, task, isFetching, isLoading, user]);

    return <>
        <MediaCardTemplate
            isLoaded={true}
            exp={true}
            card={{ label: 'Liste des notifications' }}
            data={sortedTasks}
        >
            {sortedTasks.map((s, i) => {
                const keys = getKeys(s.tac_key); return <Card key={i} style={{ marginTop: '10px' }}>
                    <Notification keys={keys} isRequis={s.tac_type === "Requis"} item={s} />
                    <CardActions
                        style={{ display: "flex", justifyContent: "space-between" }}
                    >
                        <Button className="blueButton" onClick={() => navigate(s.tac_type === 'Requis' ?
                            `/Publicite/Calendrier-Gant/Projets/${keys.camp_seq}?media=${keys.media_cd}` :
                            `/Publicite/Calendrier-Gant/Projets/${keys.camp_seq}?media=${keys.media_cd}&campagne=${keys.extraKey}&document=${keys.ridDoc}`)}>
                            Accéder
                        </Button>
                    </CardActions>
                </Card>;
            })}
        </MediaCardTemplate>
    </>;
}